'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserActionSuggestion } from '../../Entities/User/UserActionSuggestion';
import { UserActionSuggestionCollection } from '../../Collections/User/UserActionSuggestionCollection';

export class UserActionSuggestionRepository extends CoreRepository {
  public getUserActionSuggestions(userId: number, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserActionSuggestions(userId, options).then((response) => {
      const collection = new UserActionSuggestionCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserActionSuggestion();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public updateUserActionSuggestion(userId: number, suggestionId: number, payload: object = {}) {
    return this.webAPI
      .updateUserActionSuggestion(userId, suggestionId, payload)
      .then((response) => {
        const userActionSuggestion = new UserActionSuggestion();
        userActionSuggestion.hydrate(response);

        return userActionSuggestion;
      });
  }

  public getUserActionSuggestionsCountBy(
    userId: number,
    options: object = {},
    criteria: object = null
  ) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserActionSuggestionsCountBy(userId, options).then((response) => {
      return response;
    });
  }

  /*
    public getUserActionSuggestion(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getUserActionSuggestion(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let UserActionSuggestion = new UserActionSuggestion();
            UserActionSuggestion.hydrate(response);

            return UserActionSuggestion;
        });
    }

    public createUserActionSuggestion(payload: object = {}){  
    return this.webAPI.createUserActionSuggestion(payload)
      .then( response => {
        let UserActionSuggestion = new UserActionSuggestion();
        UserActionSuggestion.hydrate(response);

        return UserActionSuggestion;
      });
    }

    public updateUserActionSuggestion(payload: object = {}){  
        return this.webAPI.updateUserActionSuggestion(payload)
        .then( response => {
            let UserActionSuggestion = new UserActionSuggestion();
            UserActionSuggestion.hydrate(response);

            return UserActionSuggestion;
        });
    }

    public removeUserActionSuggestion( ){
        return this.webAPI.removeUserActionSuggestion()
        .then( response => {
            return response;
        });
    }
    */
}
